import { GET_SUPPORTS } from "constants/supports";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SUPPORTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
